export default {
  getInfo: state => state.sell,
  getRmId: state => state.rmId,
  getSaveSell: state => state.sellSave,
  loading: state => state.loading,
  modalAddCustomer: state => state.modalAddCustomer
};
